import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import TenantName from '../helper/TenantName'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionRowProps } from '../../components/kopiliot-list/type'
import { PanelType } from '../../shared/models/panel'
import ApiKey from '../../shared/models/api-key.model'

const getColumnsForTableApiKey = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<ApiKey>()
  const columns: ColumnDef<ApiKey, any>[] = [
    columnHelper.accessor((row) => row.id?.id, {
      id: 'id',
      cell: (info) => info.getValue(),
      header: () => 'Id',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => row.projectID, {
      id: 'projectID',
      cell: (info) => info.getValue(),
      header: () => 'Project ID',
      enableSorting: false,
    }),
    columnHelper.accessor((row) => row.projectName, {
      id: 'projectName',
      cell: (info) => info.getValue(),
      header: () => 'Project name',
      enableSorting: false,
    }),
    columnHelper.display({
      id: 'tenantID',
      cell: (props) => {
        return (
          <>
            <TenantName tenantId={props.row.original.tenantID.id} />
          </>
        )
      },
      header: () => 'Tenant',
    }),
    columnHelper.display({
      id: 'actions',
      cell: (props) => {
        const customerID = props.row.original.id?.id
        return (
          <>
            {actionRows && customerID && (
              <Dropdown
                className={'text-center btn-reveal-trigger'}
                onClick={(event) => event.stopPropagation()}
              >
                <Dropdown.Toggle
                  size={'sm'}
                  className={'btn-reveal'}
                  variant="falcon-default"
                  id="dropdown-assets-actions"
                >
                  <FontAwesomeIcon icon={'ellipsis-h'} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount={true}
                >
                  {actionRows.map((item) => {
                    return (
                      <Dropdown.Item
                        className={`text-${item.color || 'primary'}`}
                        key={item.title}
                        onClick={() => {
                          if (item.onClick) {
                            item.onClick(customerID)
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="fs-0 me-2"
                        />
                        {item.title}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        )
      },
      header: () => 'Actions',
    }),
  ]
  return columns
}

const defaultApiKeyActionsRow = (
  onDeleteItem: (id: string) => void,
  onEditItem: (id: string) => void
) => {
  const actionsRow: ActionRowProps[] = [
    {
      title: 'Edit',
      color: 'primary',
      icon: 'edit',
      onClick: (id) => {
        onEditItem(id)
      },
    },
    {
      title: 'Delete',
      color: 'danger',
      icon: 'trash-alt',
      onClick: (id) => {
        onDeleteItem(id)
      },
    },
  ]
  return actionsRow
}

const getDefaultSettings = (type: PanelType) => {
  switch (type) {
    case PanelType.TIME_SERIES_LINE:
      return {
        responsive: true,
      }
    default:
      return {}
  }
}

export { getColumnsForTableApiKey, defaultApiKeyActionsRow, getDefaultSettings }
